import { render, staticRenderFns } from "./ReportEtax.vue?vue&type=template&id=4ac16c5a"
import script from "./ReportEtax.vue?vue&type=script&lang=js"
export * from "./ReportEtax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports